/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Imgdesign_Err_Cutout_Missing1Inputs */

const vi_imgdesign_err_cutout_missing1 = /** @type {(inputs: Imgdesign_Err_Cutout_Missing1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa có ảnh sản phẩm đã tách nền — quay lại bước Ảnh gốc để tải ảnh`)
};

/**

* @param {Imgdesign_Err_Cutout_Missing1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const imgdesign_err_cutout_missing1 = /** @type {((inputs?: Imgdesign_Err_Cutout_Missing1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Imgdesign_Err_Cutout_Missing1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_imgdesign_err_cutout_missing1(inputs)
});
export { imgdesign_err_cutout_missing1 as "imgDesign_err_cutout_missing" }